import { GenericTableService } from './../../services/genericTable.service';
import { CompanyService } from './../../services/company.service';
import { DialogService } from './../../services/dialog.service';
import { AuthService } from './../../services/auth.service';
import { CompanyAssignLicenceDTO } from './../../models/commercialProduct.model';
import { CompanyDTO } from './../../models/company.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LookupDTO } from '../../models/lookup.model';
import { MatStepper } from '@angular/material/stepper';
import { UtilityService } from '../../services/utility.service';

import Swal from 'sweetalert2';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  registerForm: UntypedFormGroup;
  submitted = false;
  repeatPassword: string;
  company: CompanyDTO = new CompanyDTO();
  allLookupNations: Array<LookupDTO> = new Array<LookupDTO>();
  allLookupAtecos: Array<LookupDTO> = new Array<LookupDTO>();
  allLookupTaxRegime: Array<LookupDTO> = new Array<LookupDTO>();
  utilityService = UtilityService;
  currentStepIndex: number = 0;
  utm: string = null;
  namirialaccount: string = null;
  buyLicence: string = null;
  vatNummberErrMessage: string = null;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private authService: AuthService,
    private companyService: CompanyService,
    private genericTableService: GenericTableService,
    private route: ActivatedRoute) { }

  async ngOnInit() {

    //Recupero l'UTM e/o il Mynamirial e/o il BuyLicence dai queryParams se presente
    this.route.queryParams
      .subscribe(params => {
        if (params != null) {
          if (params.utm != null)
            this.utm = params.utm;

          if (params.nma != null)
            this.namirialaccount = params.nma;

          if (params.buyLicence != null)
            this.buyLicence = params.buyLicence;
        }

      });


    //Recupero le liste per gli InitialItems delle lookup
    await this.retrieveInitialItemsLookup();
    this.createForm();

  }

  async retrieveInitialItemsLookup() {
    this.allLookupNations = await this.companyService.getLookupNation();
    this.allLookupAtecos = await this.companyService.getLookupAteco();
    this.allLookupTaxRegime = await this.genericTableService.getLookupGenericTable();
  }

  changeStep(stepper: MatStepper) {
    this.currentStepIndex = stepper.selectedIndex;
  }

  /**
     * Creazione del form dati
     **/
  createForm() {
    this.registerForm = this.formBuilder.group({
      email: [this.company.Email, Validators.required],
      confirmEmail: ['', Validators.required],
      denomination: [this.company.Denomination, Validators.required],
      vatNumber: [this.company.VatNumber,  Validators.required],
      fiscalCode: [this.company.FiscalCode],
      name: [this.company.Name],
      surname: [this.company.Surname],
      telephone: [this.company.Telephone],
      address: [this.company.Address, Validators.required],
      streetNumber: [this.company.StreetNumber, Validators.required],
      city: [this.company.City, Validators.required],
      district: [this.company.District, Validators.required],
      postalCode: [this.company.PostalCode, Validators.required],
      webSite: [this.company.WebSite],
      nation: [this.company.Nation?.ID || null, Validators.required],
      taxRegime: [this.company.TaxRegime?.ID || null],
      ateco: [this.company.Ateco?.ID || null, null],
    },
      {
        validator: this.validate( ),
      }
      ,
      );


  }

  // Custom validator per match di 3 campi
  validate() {
    return (formGroup: UntypedFormGroup) => {
      const ctrlEmail = formGroup.controls['email'];
      const ctrlConfirmEmail = formGroup.controls['confirmEmail'];
      const ctrlVatNumber=formGroup.controls['vatNumber'];

      //Se ci sono già errori non c'è bisogno di controllare altro
    //    return;
     // }
      //Se la validazione fallisce imposto l'errore a true
        if (ctrlEmail.value !== ctrlConfirmEmail.value) {
          ctrlConfirmEmail.setErrors({ mustMatch: true });
        } else {
          ctrlConfirmEmail.setErrors(null);
        }

        this.vatNummberErrMessage=this.utilityService.controllaPartitaIVA(ctrlVatNumber.value);

        if (this.vatNummberErrMessage!=null) {        
          ctrlVatNumber.setErrors({ mustBeValid: true });
        } else {
          ctrlVatNumber.setErrors(null);
        }
    }
  }
  /**
   * Per accedere ai campi del form facilmente
   */
  get f() {
    return this.registerForm.controls;
  }

  /**
   * Al click del pulsante "Crea account" invio le credenziali
   * per la registrazione dell'utente
   */
  save() {

    // Se il form non è valido mi fermo
    if (this.registerForm.invalid) {
      return;
    }

    let newCompany: CompanyAssignLicenceDTO = new CompanyAssignLicenceDTO();
    let commercialLevelCompany = new LookupDTO();
    commercialLevelCompany.ID = 4;
    commercialLevelCompany.Label = 'Azienda';
    this.company.CommercialLevel = commercialLevelCompany;
    this.company.FK_ParentCompany = 3;
    this.company.AuthSPID = false;
    this.company.AuthFE = false;
    this.company.UtmDenomination = this.utm;
    this.company.NamirialAccount = this.namirialaccount;
    newCompany.Company = this.company;

    this.authService.registerCompany(newCompany)
      .then((savedCompanyID) => {
        // Registrazione effettuata con successo
        // DialogService.Success("La registrazione è andata a buon fine. Entro breve riceverai un'email con la password all'indirizzo che ci hai indicato.", null, false, 'STEP3')

        let testo: string

        if (this.namirialaccount == null) {
          testo = "La registrazione è andata a buon fine. Entro breve riceverai un'email con la password all'indirizzo che ci hai indicato."
        }
        else {
          testo = "La registrazione è andata a buon fine. Entro breve riceverai un'email all'indirizzo che ci hai indicato."
        }

        Swal.fire({
          title: null, text: testo, icon: 'success', iconHtml: '<i style="color: #A5DC86 !important; font-size: 45px !important;" id="STEP3" class="fa fa-check"></i>'
        });
        this.router.navigate(['/'], { queryParams: { buyLicence: this.buyLicence } });
            })
            .catch((err) => {
         //Nell'errore divido con il | il messaggio di errore e se c'è un secondo parametro lo considero come url a cui reindirizzare     
        const errorParts = err.message.split("|");        
        if (errorParts.length > 1) {
          DialogService.Confirm(errorParts[0], () => {
            window.location.href = errorParts[1];
          }
          );          
        }
        else{
          DialogService.Error(errorParts[0]);
        }
      });
  }
}
